import {API} from 'aws-amplify';

export const read = async () => API.get('eventmanagerAdminApi', '/hosts', {});

export const readOne = async (id) => API.get('eventmanagerAdminApi', `/hosts/${id}`, {});

export const create = async (ceo) => API.put('eventmanagerAdminApi', `/hosts`, {body: ceo});

export const update = async (ceo) => API.post('eventmanagerAdminApi', `/hosts`, {body: ceo});

export const del = async (id) => API.del('eventmanagerAdminApi', `/hosts/${id}`, {});
